
import React, { useState, useEffect } from 'react';
import Nav from '../Nav/Nav';
import Footer from '../Footer/Footer';
import { useNavigate } from 'react-router-dom';



const destinations = [
  { name: 'Kashmir', tagline: 'Heaven on Earth', duration: '5N / 6D', from: '₹32,000', img: 'https://images.unsplash.com/photo-1715457573748-8e8a70b2c1be?w=600&h=400&fit=crop&auto=format', },
  { name: 'Kerala', tagline: "God's Own Country", duration: '4N / 5D', from: '₹24,500', img: 'https://images.unsplash.com/photo-1506461883276-594a12b11cf3?w=600&h=400&fit=crop&auto=format', },
  { name: 'Rajasthan', tagline: 'Land of Maharajas', duration: '6N / 7D', from: '₹42,000', img: 'https://images.unsplash.com/photo-1695956353120-54ce5e91632b?w=600&h=400&fit=crop&auto=format', },
  { name: 'Goa', tagline: 'Sun, Sand & Sea', duration: '3N / 4D', from: '₹18,000', img: 'https://images.unsplash.com/photo-1512343879784-a960bf40e7f2?w=600&h=400&fit=crop&auto=format', },
];

const services = [
  { icon: '✈', title: 'Flight Tickets', desc: 'Domestic and international flights with expert fare assistance and flexible booking.', page: 'flights', color: '#F47B20', },
  { icon: '🏔', title: 'Tours & Holidays', desc: 'Curated leisure and luxury packages across India and beyond, built around you.', page: 'tours', color: '#16865B', },
  { icon: '🛂', title: 'Visa Consultancy', desc: 'Professional visa guidance and document assistance for Indian travellers worldwide.', page: 'visa', color: '#F47B20', },
  { icon: '💼', title: 'Corporate Travel', desc: 'Seamless travel management for businesses — policy-aligned, cost-controlled.', page: 'corporate', color: '#000000', },
  { icon: '🏨', title: 'Hotels', desc: 'Carefully selected hotels across India from boutique stays to 5-star luxury.', page: 'hotels', color: '#7B3F00', },
];

const stats = [
  { value: '10+', label: 'Years of Experience' },
  { value: '5,000+', label: 'Happy Travellers' },
  { value: '50+', label: 'Indian Destinations' },
  { value: '24/7', label: 'Travel Support' },
];

const testimonials = [
  { name: 'Priya Sharma', location: 'Mumbai', text: "Aerova planned our Rajasthan honeymoon perfectly. Every hotel, every transfer — seamlessly arranged. We didn't have to worry about a thing.", rating: 5, trip: 'Royal Rajasthan Package', },
  { name: 'Arjun Mehta', location: 'Hyderabad', text: "Got our UK visa with Aerova's help. The document checklist was spot-on, and their consultant was available every step of the way.", rating: 5, trip: 'UK Visa Consultancy', },
  { name: 'Sunita Reddy', location: 'Bengaluru', text: 'As a corporate travel manager, Aerova has transformed how we handle business trips. Dedicated desk, instant support, zero hassle.', rating: 5, trip: 'Corporate Travel Management', },
];

const tabs = ['Flight Tickets', 'Tours / Holidays', 'Visa Consultancy', 'Corporate Travel', 'Hotels'];

export default function Home({ onNavigate, onQuote, onExpert }) {
  const [activeTab, setActiveTab] = useState(0);
  const navigate = useNavigate();
  const [flightFrom, setFlightFrom] = useState('Hyderabad (HYD)');
  const [flightTo, setFlightTo] = useState('Mumbai (BOM)');
  const [tripType, setTripType] = useState('roundtrip');
  const [isDesktop, setIsDesktop] = useState(
    typeof window !== 'undefined' ? window.innerWidth >= 768 : true
  );

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Reusable inline style constants
  const labelStyle = { display: 'block', fontSize: '11px', fontWeight: 600, marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.05em', color: 'var(--text-muted, #718096)', fontFamily: 'Manrope, sans-serif', };
  const inputStyle = { width: '100%', padding: '10px 12px', borderRadius: '8px', fontSize: '14px', fontWeight: 500, outline: 'none', boxSizing: 'border-box', border: '1.5px solid var(--border, #e2e8f0)', color: 'var(--navy, #0a192f)', fontFamily: 'Manrope, sans-serif', backgroundColor: '#ffffff', };
  const btnGoldStyle = { background: 'var(--gold, #F47B20)', color: 'var(--navy, #0a192f)', fontWeight: 700, cursor: 'pointer', border: 'none', fontFamily: 'Manrope, sans-serif', transition: 'all 0.2s ease', };
  const sectionLabelStyle = { fontSize: '13px', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'var(--gold, #F47B20)', marginBottom: '12px', fontFamily: 'Manrope, sans-serif', };

  return (
    <>
      <Nav />
      <div style={{ fontFamily: 'Manrope, sans-serif', color: 'var(--navy, #0a192f)', overflowX: 'hidden' }}>

        {/* HERO */}
        <section style={{ position: 'relative', minHeight: '100vh', display: 'flex', alignItems: 'center', backgroundColor: 'var(--navy, #0a192f)', }}>
          <img src="https://images.unsplash.com/photo-1695956353120-54ce5e91632b?w=1600&h=900&fit=crop&auto=format" alt="Udaipur City Palace at golden hour" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', opacity: 0.55, }} />
          <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'linear-gradient(180deg, rgba(10,25,47,0.4) 0%, rgba(10,25,47,0.85) 100%)', }} />

          <div style={{ position: 'relative', zIndex: 10, maxWidth: '1280px', margin: '0 auto', padding: '112px 24px 64px 24px', width: '100%', boxSizing: 'border-box', }}>
            <div style={{ maxWidth: '672px' }}>
              <p style={sectionLabelStyle}>India's Premium Travel Partner</p>
              <h1 style={{ fontSize: isDesktop ? '56px' : '38px', fontWeight: 800, color: '#ffffff', lineHeight: 1.1, marginBottom: '20px', fontFamily: 'Manrope, sans-serif', }}>
                Travel Better.
                <br />
                <span style={{ background: 'linear-gradient(90deg, #F47B20 0%, #FFB020 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', }}>Travel With Confidence.</span>
              </h1>
              <p style={{ fontSize: '18px', color: 'rgba(255, 255, 255, 0.75)', maxWidth: '512px', marginBottom: '32px', lineHeight: '1.6', }}>Flights, holidays, visa assistance, corporate travel and hotels — thoughtfully arranged by travel experts in India.</p>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
                <button onClick={onQuote} style={{ ...btnGoldStyle, padding: '14px 28px', borderRadius: '12px', fontSize: '15px', }}>Plan My Trip</button>
                <button onClick={onExpert} style={{ padding: '14px 28px', borderRadius: '12px', fontSize: '15px', fontWeight: 600, color: '#ffffff', cursor: 'pointer', border: '1.5px solid rgba(255, 255, 255, 0.35)', fontFamily: 'Manrope, sans-serif', background: 'rgba(255, 255, 255, 0.06)', }}              >Talk to an Expert</button>
              </div>
            </div>

            {/* Floating trust badges */}
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', marginTop: '40px' }}>
              {['IATA Accredited', 'GST Registered', '10+ Years Trusted', '5-Star Rated'].map((badge) => (
                <span key={badge} style={{ padding: '4px 12px', borderRadius: '9999px', fontSize: '12px', fontWeight: 600, background: 'rgba(244,123,32,0.15)', border: '1px solid rgba(244,123,32,0.35)', color: 'var(--gold, #F47B20)', fontFamily: 'Manrope, sans-serif', }}>✓ {badge}</span>
              ))}
            </div>
          </div>
        </section>

        {/* SERVICE TABS SEARCH */}
        <section style={{ maxWidth: '1280px', margin: '-48px auto 0 auto', padding: '0 24px', position: 'relative', zIndex: 20, boxSizing: 'border-box', }}>
          <div style={{ borderRadius: '16px', overflow: 'hidden', background: 'var(--white, #ffffff)', boxShadow: '0 8px 40px rgba(0,0,0,0.18)', border: '1px solid var(--border, #e2e8f0)', }}>
            <div style={{ display: 'flex', overflowX: 'auto', borderBottom: '1px solid var(--border, #e2e8f0)', }}>
              {tabs.map((tab, i) => (
                <button key={tab} onClick={() => setActiveTab(i)} style={{ flexShrink: 0, padding: '16px 20px', fontSize: '13px', fontWeight: 600, whiteSpace: 'nowrap', cursor: 'pointer', border: 'none', outline: 'none', fontFamily: 'Manrope, sans-serif', color: activeTab === i ? 'var(--navy, #0a192f)' : 'var(--text-muted, #718096)', borderBottom: activeTab === i ? '2px solid var(--gold, #F47B20)' : '2px solid transparent', background: activeTab === i ? 'rgba(244,123,32,0.05)' : 'transparent', }}>{tab}</button>
              ))}
            </div>

            {/* Tab Content */}
            <div style={{ padding: '24px' }}>
              {activeTab === 0 && (
                <div>
                  <div style={{ display: 'flex', gap: '12px', marginBottom: '16px' }}>
                    {['Round Trip', 'One Way', 'Multi City'].map((t, i) => (
                      <button key={t} onClick={() => setTripType(i === 0 ? 'roundtrip' : 'oneway')} style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', fontWeight: 500, background: 'none', border: 'none', cursor: 'pointer', padding: 0, color: (tripType === 'roundtrip' && i === 0) || (tripType === 'oneway' && i === 1) ? 'var(--navy, #0a192f)' : 'var(--text-muted, #718096)', fontFamily: 'Manrope, sans-serif', }}>
                        <span style={{ width: '16px', height: '16px', borderRadius: '50%', border: `2px solid ${(tripType === 'roundtrip' && i === 0) || (tripType === 'oneway' && i === 1) ? 'var(--navy, #0a192f)' : 'var(--border, #e2e8f0)'}`, display: 'flex', alignItems: 'center', justifyContent: 'center', boxSizing: 'border-box', }}>
                          {((tripType === 'roundtrip' && i === 0) || (tripType === 'oneway' && i === 1)) && (
                            <span style={{ width: '8px', height: '8px', borderRadius: '50%', display: 'block', background: 'var(--navy, #0a192f)', }} />
                          )}
                        </span>
                        {t}
                      </button>
                    ))}
                  </div>

                  <div style={{ display: 'grid', gridTemplateColumns: isDesktop ? 'repeat(5, 1fr)' : 'repeat(2, 1fr)', gap: '12px', }}>
                    <div>
                      <label style={labelStyle}>From</label>
                      <input value={flightFrom} onChange={(e) => setFlightFrom(e.target.value)} style={inputStyle} />
                    </div>
                    <div>
                      <label style={labelStyle}>To</label>
                      <input value={flightTo} onChange={(e) => setFlightTo(e.target.value)} style={inputStyle} />
                    </div>
                    <div>
                      <label style={labelStyle}>Departure</label>
                      <input type="date" defaultValue="2026-09-15" style={inputStyle} />
                    </div>
                    <div>
                      <label style={labelStyle}>Travellers & Class</label>
                      <select style={inputStyle}>
                        <option>2 Adults · Economy</option>
                        <option>1 Adult · Economy</option>
                        <option>2 Adults · Business</option>
                      </select>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'flex-end', gridColumn: !isDesktop ? 'span 2' : 'auto' }}>
                      <button onClick={() => navigate('/flights')} style={{ ...btnGoldStyle, width: '100%', padding: '10px 0', borderRadius: '8px', fontSize: '14px', }}>Search Flights</button>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === 1 && (
                <div style={{ display: 'grid', gridTemplateColumns: isDesktop ? '2fr 1fr 1fr 1fr' : 'repeat(2, 1fr)', gap: '12px', }}>
                  <div style={{ gridColumn: !isDesktop ? 'span 2' : 'auto' }}>
                    <label style={labelStyle}>Destination</label>
                    <select style={inputStyle}>
                      <option>Kashmir</option>
                      <option>Kerala</option>
                      <option>Rajasthan</option>
                      <option>Goa</option>
                      <option>Himachal Pradesh</option>
                      <option>Andaman</option>
                    </select>
                  </div>
                  <div>
                    <label style={labelStyle}>Travel Date</label>
                    <input type="date" defaultValue="2026-10-01" style={inputStyle} />
                  </div>
                  <div>
                    <label style={labelStyle}>Travellers</label>
                    <select style={inputStyle}>
                      <option>2 Adults</option>
                      <option>1 Adult</option>
                      <option>2 Adults, 1 Child</option>
                      <option>4 Adults</option>
                    </select>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'flex-end', gridColumn: !isDesktop ? 'span 2' : 'auto' }}>
                    <button onClick={() => onNavigate('tours')} style={{ ...btnGoldStyle, width: '100%', padding: '10px 0', borderRadius: '8px', fontSize: '14px', }}>Explore Tours</button>
                  </div>
                </div>
              )}

              {activeTab === 2 && (
                <div style={{ display: 'grid', gridTemplateColumns: isDesktop ? '2fr 1fr 1fr' : 'repeat(2, 1fr)', gap: '12px', }}>
                  <div style={{ gridColumn: !isDesktop ? 'span 2' : 'auto' }}>
                    <label style={labelStyle}>Visa Destination</label>
                    <select style={inputStyle}>
                      <option>United Kingdom</option>
                      <option>United States (USA)</option>
                      <option>Canada</option>
                      <option>Australia</option>
                      <option>Schengen (Europe)</option>
                      <option>UAE / Dubai</option>
                      <option>Singapore</option>
                      <option>Japan</option>
                    </select>
                  </div>
                  <div>
                    <label style={labelStyle}>Visa Type</label>
                    <select style={inputStyle}>
                      <option>Tourist Visa</option>
                      <option>Business Visa</option>
                      <option>Student Visa</option>
                      <option>Family Visa</option>
                    </select>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                    <button onClick={() => onNavigate('visa')} style={{ ...btnGoldStyle, width: '100%', padding: '10px 0', borderRadius: '8px', fontSize: '14px', }}>Check Visa</button>
                  </div>
                </div>
              )}

              {activeTab === 3 && (
                <div style={{ display: 'grid', gridTemplateColumns: isDesktop ? 'repeat(4, 1fr)' : 'repeat(2, 1fr)', gap: '12px', }}>
                  <div>
                    <label style={labelStyle}>Company Name</label>
                    <input placeholder="e.g. Infosys Ltd." style={inputStyle} />
                  </div>
                  <div>
                    <label style={labelStyle}>Travel Requirement</label>
                    <select style={inputStyle}>
                      <option>Corporate Flights</option>
                      <option>Corporate Hotels</option>
                      <option>Group Travel</option>
                      <option>Full Travel Management</option>
                    </select>
                  </div>
                  <div>
                    <label style={labelStyle}>Monthly Trips</label>
                    <select style={inputStyle}>
                      <option>1–10 trips/month</option>
                      <option>10–50 trips/month</option>
                      <option>50+ trips/month</option>
                    </select>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'flex-end', gridColumn: !isDesktop ? 'span 2' : 'auto' }}>
                    <button onClick={() => onNavigate('corporate')} style={{ ...btnGoldStyle, width: '100%', padding: '10px 0', borderRadius: '8px', fontSize: '14px', }}>Request Consultation</button>
                  </div>
                </div>
              )}

              {activeTab === 4 && (
                <div style={{ display: 'grid', gridTemplateColumns: isDesktop ? 'repeat(5, 1fr)' : 'repeat(2, 1fr)', gap: '12px', }}>
                  <div style={{ gridColumn: !isDesktop ? 'span 2' : 'auto' }}>
                    <label style={labelStyle}>City</label>
                    <select style={inputStyle}>
                      <option>Goa</option>
                      <option>Mumbai</option>
                      <option>Delhi</option>
                      <option>Udaipur</option>
                      <option>Jaipur</option>
                      <option>Kashmir</option>
                    </select>
                  </div>
                  <div>
                    <label style={labelStyle}>Check-in</label>
                    <input type="date" defaultValue="2026-09-15" style={inputStyle} />
                  </div>
                  <div>
                    <label style={labelStyle}>Check-out</label>
                    <input type="date" defaultValue="2026-09-18" style={inputStyle} />
                  </div>
                  <div>
                    <label style={labelStyle}>Guests & Rooms</label>
                    <select style={inputStyle}>
                      <option>2 Adults · 1 Room</option>
                      <option>1 Adult · 1 Room</option>
                      <option>4 Adults · 2 Rooms</option>
                    </select>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'flex-end', gridColumn: !isDesktop ? 'span 2' : 'auto' }}>
                    <button onClick={() => onNavigate('hotels')} style={{ ...btnGoldStyle, width: '100%', padding: '10px 0', borderRadius: '8px', fontSize: '14px', }}>Search Hotels</button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>

        {/* SERVICES */}
        <section style={{ maxWidth: '1280px', margin: '0 auto', padding: '80px 24px', boxSizing: 'border-box', }}>
          <div style={{ textAlign: 'center', marginBottom: '48px' }}>
            <p style={sectionLabelStyle}>What We Do</p>
            <h2 style={{ fontSize: '36px', fontWeight: 800, fontFamily: 'Manrope, sans-serif', color: 'var(--navy, #0a192f)', margin: '0 0 12px 0', }}>Five Services. One Expert Team.</h2>
            <p style={{ margin: 0, fontSize: '15px', maxWidth: '576px', marginLeft: 'auto', marginRight: 'auto', color: 'var(--text-secondary, #4a5568)', }}>
              From your first flight search to visa approval and luxury hotel stays, Aerova handles it all.
            </p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: isDesktop ? 'repeat(5, 1fr)' : '1fr', gap: '16px', }}>
            {services.map((s) => (
              <button key={s.title} onClick={() => onNavigate(s.page)} style={{ textAlign: 'left', padding: '20px', borderRadius: '12px', background: 'var(--white, #ffffff)', border: '1px solid var(--border, #e2e8f0)', boxShadow: 'var(--card-shadow, 0 4px 20px rgba(0,0,0,0.05))', cursor: 'pointer', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', }}>
                <div>
                  <div style={{ width: '44px', height: '44px', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', marginBottom: '16px', background: `${s.color}14`, }}>{s.icon}</div>
                  <h3 style={{ fontWeight: 700, fontSize: '15px', marginBottom: '8px', marginTop: 0, fontFamily: 'Manrope, sans-serif', color: 'var(--navy, #0a192f)', }}>{s.title}</h3>
                  <p style={{ fontSize: '13px', lineHeight: '1.5', color: 'var(--text-secondary, #4a5568)', margin: 0, }}>{s.desc}</p>
                </div>
                <p style={{ marginTop: '12px', marginBottom: 0, fontSize: '12px', fontWeight: 600, color: s.color, fontFamily: 'Manrope, sans-serif', }}>Learn more →</p>
              </button>
            ))}
          </div>
        </section>

        {/* DESTINATIONS */}
        <section style={{ background: 'var(--navy, #0a192f)', padding: '80px 0', }}>
          <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 24px', boxSizing: 'border-box' }}>
            <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', marginBottom: '48px', }}>
              <div>
                <p style={sectionLabelStyle}>Popular Destinations</p>
                <h2 style={{ fontSize: '36px', fontWeight: 800, color: '#ffffff', fontFamily: 'Manrope, sans-serif', margin: 0, }}>Discover India Your Way.</h2>
              </div>
              {isDesktop && (
                <button onClick={() => navigate('/tours')} style={{ padding: '10px 20px', borderRadius: '8px', fontSize: '13px', fontWeight: 700, background: 'transparent', cursor: 'pointer', border: '1.5px solid var(--gold, #F47B20)', color: 'var(--gold, #F47B20)', fontFamily: 'Manrope, sans-serif', }}>View All Tours</button>
              )}
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: isDesktop ? 'repeat(4, 1fr)' : '1fr', gap: '20px', }}>
              {destinations.map((d) => (
                <div key={d.name} onClick={() => navigate('/tours')} style={{ borderRadius: '16px', overflow: 'hidden', cursor: 'pointer', border: '1px solid rgba(255,255,255,0.08)', display: 'flex', flexDirection: 'column', }}>
                  <div style={{ position: 'relative', height: '208px', backgroundColor: '#334155' }}>
                    <img src={d.img} alt={d.name} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                    <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, transparent 55%)', }} />
                    <div style={{ position: 'absolute', bottom: '16px', left: '16px', right: '16px', }}>
                      <p style={{ color: '#ffffff', fontWeight: 800, fontSize: '20px', margin: 0, fontFamily: 'Manrope, sans-serif', }}>{d.name}</p>
                      <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '12px', margin: '4px 0 0 0' }}>{d.tagline}</p>
                    </div>
                  </div>

                  <div style={{ padding: '16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: 'rgba(255,255,255,0.05)', }}>
                    <div>
                      <p style={{ fontSize: '12px', color: 'rgba(255,255,255,0.5)', margin: 0 }}>{d.duration}</p>
                      <p style={{ fontWeight: 700, fontSize: '15px', color: 'var(--gold, #F47B20)', margin: '2px 0 0 0', fontFamily: 'Manrope, sans-serif', }}>From {d.from}</p>
                    </div>
                    <button style={{ ...btnGoldStyle, padding: '6px 12px', borderRadius: '8px', fontSize: '12px', }}>Explore</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* WHY AEROVA */}
        <section style={{ maxWidth: '1280px', margin: '0 auto', padding: '80px 24px', boxSizing: 'border-box', }}>
          <div style={{ display: 'grid', gridTemplateColumns: isDesktop ? '1fr 1fr' : '1fr', gap: '64px', alignItems: 'center', }}>
            <div>
              <p style={sectionLabelStyle}>Why Choose Us</p>
              <h2 style={{ fontSize: '36px', fontWeight: 800, marginBottom: '20px', fontFamily: 'Manrope, sans-serif', color: 'var(--navy, #0a192f)', lineHeight: 1.2, }}>
                Travel Is Personal.
                <br />
                So Is Our Service.
              </h2>
              <p style={{ fontSize: '15px', lineHeight: '1.6', marginBottom: '24px', color: 'var(--text-secondary, #4a5568)', }}>
                We are a team of passionate travel consultants based in India. Every itinerary is hand-crafted, every hotel hand-picked, and every client personally cared for. No call centres, no chatbots — just real experts.
              </p>

              {[
                { icon: '🎯', title: 'Personalized Planning', desc: 'Every trip is designed specifically for you — not a template.' },
                { icon: '📞', title: '24/7 Expert Support', desc: 'Your consultant is available round the clock during your journey.' },
                { icon: '💰', title: 'Transparent Pricing', desc: 'No hidden charges. Full pricing with GST upfront, always.' },
                { icon: '🏆', title: 'IATA Accredited', desc: 'Certified agency with direct airline access and corporate fares.' },
              ].map((f) => (
                <div key={f.title} style={{ display: 'flex', gap: '16px', marginBottom: '20px' }}>
                  <span style={{ fontSize: '24px', marginTop: '2px' }}>{f.icon}</span>
                  <div>
                    <p style={{ fontWeight: 700, fontSize: '15px', margin: 0, fontFamily: 'Manrope, sans-serif', color: 'var(--navy, #0a192f)', }}>{f.title}</p>
                    <p style={{ fontSize: '13px', marginTop: '2px', marginBottom: 0, color: 'var(--text-secondary, #4a5568)', }}>{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <div style={{ position: 'relative' }}>
              <div style={{ borderRadius: '16px', overflow: 'hidden', height: '384px', backgroundColor: '#e2e8f0', }}>
                <img src="https://images.unsplash.com/photo-1715405155683-e36aff15fd53?w=700&h=500&fit=crop&auto=format" alt="Luxury hotel interior" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
              </div>

              {/* Floating stat card */}
              <div style={{ position: 'absolute', bottom: '-24px', left: isDesktop ? '-24px' : '16px', padding: '20px', borderRadius: '12px', background: 'var(--navy, #0a192f)', boxShadow: '0 8px 32px rgba(0,0,0,0.3)', }}>
                <p style={{ fontSize: '30px', fontWeight: 800, margin: 0, color: 'var(--gold, #F47B20)', fontFamily: 'Manrope, sans-serif', }}>5,000+</p>
                <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.7)', margin: '2px 0 0 0' }}>Happy travellers across India</p>
              </div>
            </div>
          </div>
        </section>

        {/* STATS */}
        <section style={{ background: 'var(--royal, #0f2744)', padding: '56px 0', }}>
          <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 24px', display: 'grid', gridTemplateColumns: isDesktop ? 'repeat(4, 1fr)' : 'repeat(2, 1fr)', gap: '32px', textAlign: 'center', boxSizing: 'border-box', }}>
            {stats.map((s) => (
              <div key={s.label}>
                <p style={{ fontSize: '36px', fontWeight: 800, color: '#ffffff', margin: 0, fontFamily: 'Manrope, sans-serif', }}>{s.value}</p>
                <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.7)', margin: '4px 0 0 0' }}>{s.label}</p>
              </div>
            ))}
          </div>
        </section>

        {/* TESTIMONIALS */}
        <section style={{ maxWidth: '1280px', margin: '0 auto', padding: '80px 24px', boxSizing: 'border-box', }}>
          <div style={{ textAlign: 'center', marginBottom: '48px' }}>
            <p style={sectionLabelStyle}>Client Stories</p>
            <h2 style={{ fontSize: '36px', fontWeight: 800, fontFamily: 'Manrope, sans-serif', color: 'var(--navy, #0a192f)', margin: 0, }}>What Our Travellers Say</h2>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: isDesktop ? 'repeat(3, 1fr)' : '1fr', gap: '24px', }}>
            {testimonials.map((t) => (
              <div key={t.name} style={{ padding: '24px', borderRadius: '16px', background: 'var(--white, #ffffff)', border: '1px solid var(--border, #e2e8f0)', boxShadow: 'var(--card-shadow, 0 4px 20px rgba(0,0,0,0.05))', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', }}>
                <div>
                  <div style={{ display: 'flex', gap: '2px', marginBottom: '16px' }}>
                    {Array.from({ length: t.rating }).map((_, i) => (
                      <span key={i} style={{ color: 'var(--gold, #F47B20)' }}>★</span>
                    ))}
                  </div>
                  <p style={{ fontSize: '14px', lineHeight: '1.6', marginBottom: '20px', marginTop: 0, color: 'var(--text-secondary, #4a5568)', }}>"{t.text}"</p>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <div>
                    <p style={{ fontWeight: 700, fontSize: '14px', margin: 0, fontFamily: 'Manrope, sans-serif', color: 'var(--navy, #0a192f)', }}>{t.name}</p>
                    <p style={{ fontSize: '12px', margin: '2px 0 0 0', color: 'var(--text-muted, #718096)' }}>{t.location}</p>
                  </div>
                  <span style={{ fontSize: '11px', padding: '4px 10px', borderRadius: '9999px', fontWeight: 600, background: 'rgba(244,123,32,0.12)', color: 'var(--gold-dark, #d96614)', fontFamily: 'Manrope, sans-serif', }}>{t.trip}</span>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* CTA SECTION */}
        <section style={{ margin: '0 24px 80px 24px', borderRadius: '24px', overflow: 'hidden', position: 'relative', background: 'var(--navy, #0a192f)', }}>
          <img src="https://images.unsplash.com/photo-1661174607003-d9d36388c916?w=1400&h=400&fit=crop&auto=format" alt="Kerala backwaters" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', opacity: 0.3, }} />
          <div style={{ position: 'relative', zIndex: 10, maxWidth: '672px', margin: '0 auto', textAlign: 'center', padding: '64px 24px', }}>
            <p style={sectionLabelStyle}>Start Today</p>
            <h2 style={{ fontSize: '36px', fontWeight: 800, color: '#ffffff', marginBottom: '16px', marginTop: 0, fontFamily: 'Manrope, sans-serif', }}>Ready to Plan Your Next Journey?</h2>
            <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '15px', marginBottom: '32px', marginTop: 0, }}>Speak with one of our travel consultants and let us craft your perfect trip.</p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', justifyContent: 'center' }}>
              <button onClick={onQuote} style={{ ...btnGoldStyle, padding: '14px 32px', borderRadius: '12px', fontSize: '15px', }}>Get a Free Quote</button>
              <button onClick={onExpert} style={{ padding: '14px 32px', borderRadius: '12px', fontSize: '15px', fontWeight: 600, color: '#ffffff', cursor: 'pointer', border: '1.5px solid rgba(255,255,255,0.3)', fontFamily: 'Manrope, sans-serif', background: 'rgba(255,255,255,0.06)', }}>Talk to an Expert</button>
            </div>
          </div>
        </section>

      </div>
      <Footer />
    </>

  );
}